/* tws-collection.js — 07/10/2026 — pages collection « premium »
   1) Carrousels ([data-twsc-carrousel]) : flèches + barre de progression ; rien ne
      défile tout seul. Si tout tient à l'écran, flèches et barre sont masquées.
   2) Texte de la collection ([data-twsc-pli]) : replié avec « Lire la suite ».
      Le texte complet reste dans le HTML (Google le lit en entier). */
(function () {
  function carrousel(w) {
    if (w.dataset.twscPret) return; w.dataset.twscPret = '1';
    var p = w.querySelector('[data-twsc-piste]'); if (!p) return;
    var bar = w.querySelector('.twsc-prog i');
    var prev = w.querySelector('[data-dir="-1"]'), next = w.querySelector('[data-dir="1"]');
    function maj() {
      var max = p.scrollWidth - p.clientWidth;
      w.classList.toggle('is-statique', max <= 2);
      if (bar) {
        var vis = p.scrollWidth ? p.clientWidth / p.scrollWidth : 1;
        bar.style.width = (vis * 100) + '%';
        bar.style.left = (max > 0 ? (p.scrollLeft / max) * (1 - vis) * 100 : 0) + '%';
      }
      if (prev) prev.disabled = p.scrollLeft <= 2;
      if (next) next.disabled = p.scrollLeft >= max - 2;
    }
    function pas(d) {
      var li = p.querySelector('li');
      var g = parseFloat(getComputedStyle(p).columnGap) || 0;
      p.scrollBy({ left: d * (li ? li.getBoundingClientRect().width + g : p.clientWidth * 0.8), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { pas(-1); });
    if (next) next.addEventListener('click', function () { pas(1); });
    p.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    window.addEventListener('load', maj);
    maj();
  }
  function pli(t) {
    if (t.dataset.twscPret) return; t.dataset.twscPret = '1';
    var c = t.querySelector('.twsc-texte__corps'), b = t.querySelector('.twsc-texte__suite');
    if (!c || !b) return;
    var h = parseInt(getComputedStyle(t).getPropertyValue('--twsc-pli'), 10) || 200;
    if (c.scrollHeight <= h + 80) return;
    c.classList.add('is-plie'); b.hidden = false;
    b.addEventListener('click', function () {
      var plie = c.classList.toggle('is-plie');
      b.setAttribute('aria-expanded', plie ? 'false' : 'true');
      b.textContent = plie ? b.dataset.plus : b.dataset.moins;
      if (plie) t.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  }
  function init() {
    document.querySelectorAll('[data-twsc-carrousel]').forEach(carrousel);
    document.querySelectorAll('[data-twsc-pli]').forEach(pli);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();